
import { OneTimePaymentService } from './creationServices/oneTimePaymentService';
import { CheckoutService } from './creationServices/checkoutService';
import { PaymentRecordService } from './creationServices/paymentRecordService';

/**
 * Service for creating payments and checkout sessions
 */
export const PaymentCreationService = {
  ...OneTimePaymentService,
  ...CheckoutService,
  ...PaymentRecordService
};
